import React, { FC, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { Modal, ModalBody, ModalFooter, ModalHeader, FormGroup, Label, Input } from 'reactstrap';
import { useAppDispatch } from '../redux/hooks';
import { createProjectRequested } from '../redux/reducers/project.slice';

type ModalPurchaseNFTProps = {
  isOpen: boolean;
  toggle(): void;
};

const ModalCreateProject: FC<ModalPurchaseNFTProps> = ({ isOpen, toggle }) => {
  const dispatch = useAppDispatch();
  const [selectedProjectType, setSelectedProjectType] = useState<string>('classic');

  function createProject() {
    dispatch(createProjectRequested({ type: selectedProjectType }));

    window.gtag('event', 'create_project');
  }

  return (
    <>
      <Modal isOpen={isOpen} toggle={toggle} className="modal-purchase">
        <ModalHeader toggle={toggle}>New project</ModalHeader>
        <ModalBody className="project-type-container">
          <FormGroup className="project-type-item">
            <Input
              type="radio"
              value="classic"
              checked={selectedProjectType === 'classic'}
              onChange={(e) => setSelectedProjectType(e.target.value)}
              id="classic-project"
            />
            <Label for="classic-project">Classic project</Label>
          </FormGroup>
          <FormGroup className="project-type-item">
            <Input
              type="radio"
              value="funding"
              checked={selectedProjectType === 'funding'}
              onChange={(e) => setSelectedProjectType(e.target.value)}
              id="funding-project"
            />
            <Label for="funding-project">Funding project</Label>
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <button onClick={createProject} className="app-btn color-primary">
            Continue
          </button>
        </ModalFooter>
      </Modal>
    </>
  );
};

ModalCreateProject.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
};

ModalCreateProject.defaultProps = {
  toggle: () => {},
};

export default ModalCreateProject;
